var service = {};

service.API_URL = process.env?.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://192.168.1.184:5010';

export default service;
